import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { CommonProductDetailsComponentBase } from '../../CommonProductDetailsComponentBase';
import { ProductVendorLogoComponent } from '../product-vendor-logo';

@Component({
  selector: 'ideal-product-vendor-pod',
  imports: [ProductVendorLogoComponent, RouterModule, MatButtonModule],
  templateUrl: './product-vendor-pod.component.html',
  styleUrl: './product-vendor-pod.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.display]': 'hasShop() && hasLogo() ? null : "none"',
  },
})
export class ProductVendorPodComponent extends CommonProductDetailsComponentBase {
  protected readonly vendor = computed(() => this.productDetails()?.vendor);
  protected readonly hasShop = computed(() => this.vendor()?.hasShop ?? false);
  protected readonly hasLogo = computed(() => !!this.vendor()?.logoUrl);
  protected readonly ready = computed(() => !this.productDetails.error() && !this.productDetails.loading() && !!this.productDetails());
}
